import React, { Component } from "react";
import cx from "classnames";
import _find from "lodash/find";
import _includes from "lodash/includes";
import _differenceBy from "lodash/differenceBy";
import _partition from "lodash/partition";
//
import withMyGoogleApi from "../utils/withMyGoogleApi";

class Map extends Component {
  componentDidMount() {
    this.createMap();
  }

  componentDidUpdate(prevProps, prevState) {
    const { activeMarkerKey: oldKey, markers: oldMarkers } = prevProps;
    const { activeMarkerKey: newKey, markers: newMarkers } = this.props;

    this.updateActive(oldKey, newKey);
    this.updateMarkers(oldMarkers, newMarkers);
  }

  updateActive(oldKey, newKey) {
    if (oldKey !== newKey) {
      const { icon, iconActive } = this.props;
      let marker;

      // Update icon of previously selected Marker
      marker = _find(this.markers, (marker) => marker.key === oldKey);
      if (marker) {
        marker.setIcon(icon);
      }

      // Update icon of current selected Marker
      marker = _find(this.markers, (marker) => marker.key === newKey);
      if (marker) {
        marker.setIcon(iconActive);
      }
    }
  }

  updateMarkers(oldMarkers, newMarkers) {
    const toRemove = _differenceBy(oldMarkers, newMarkers, "key");
    const toAdd = _differenceBy(newMarkers, oldMarkers, "key");

    if (toRemove.length) {
      const removeKeys = toRemove.map((marker) => marker.key);
      const grouped = _partition(this.markers, (marker) =>
        _includes(removeKeys, marker.key)
      );

      this.destroyMarkers(grouped[0]);
      this.markers = grouped[1];
    }

    if (toAdd.length) {
      this.markers.push(...this.createMarkers(toAdd));
    }

    if (this.markers.length === 1) {
      const marker = this.markers[0];

      if (marker instanceof google.maps.Circle) {
        this.map.panTo(marker.center);
      } else {
        this.map.panTo(marker.getPosition());
      }
    }
  }

  createMap() {
    const { google, lat, lng, onClick } = this.props;
    const options = { ...this.props.options };

    if (lat && lng) {
      options.center = new google.maps.LatLng(lat, lng);
    }

    this.map = new google.maps.Map(this.mapElement, options);

    if (onClick) {
      this.map.addListener("click", onClick);
    }

    const { markers } = this.props;

    if (markers.length > 1) {
      this.bounds = new google.maps.LatLngBounds();
    }

    this.markers = this.createMarkers(markers);
  }

  createMarkers(markers) {
    markers = markers.map((props) => this.createMarker(props));
    //
    if (this.bounds) {
      this.map.fitBounds(this.bounds);
    }

    if (markers.length === 1) {
      const marker = markers[0];
      const center = marker.getPosition
        ? marker.getPosition()
        : marker.getCenter();

      this.map.setZoom(this.props.options.zoom || 15);
      this.map.setCenter(center);
    }

    return markers;
  }

  createMarker(props) {
    const { google, activeMarkerKey, icon, iconActive, approx } = this.props;

    const position = new google.maps.LatLng(props.position);
    let marker;

    if (approx) {
      marker = new google.maps.Circle({
        strokeColor: "#FF2484",
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: "#FF2484",
        fillOpacity: 0.2,
        center: position,
        radius: approx / 2, // meters
      });
    } else {
      marker = new google.maps.Marker({
        ...props,
        icon: props.key === activeMarkerKey ? iconActive : icon,
        position,
      });
    }

    marker.setMap(this.map);

    if (props.onClick) {
      marker.addListener("click", props.onClick);
    }

    if (this.bounds) {
      this.bounds.extend(position);
    }

    return marker;
  }

  destroyMarkers(markers) {
    markers.forEach((marker) => marker.setMap(null));
  }

  _mapRef = (el) => {
    this.mapElement = el;
  };

  render() {
    const { fullScreen, height } = this.props;
    return (
      <div className={cx("o-map", { "o-map--full": fullScreen })}>
        <div
          className="o-map__canvas"
          style={{ height: `${height}px` }}
          ref={this._mapRef}
        />
      </div>
    );
  }
}

Map.defaultProps = {
  fullScreen: false,
  markers: [],
  height: 250,
};

export default withMyGoogleApi(Map);
